/*
 * Sara - asistent za sara-home.rs   [ASSET VERZIJA - 23.07.2026]
 *
 * Ovo je cist JavaScript. U njemu nema nijednog HTML taga, pa ne moze da
 * pukne bez obzira gde zavrsi u temi.
 *
 * KAKO SE POSTAVLJA:
 * 1) Edit code -> Assets -> Add a new asset -> Create a blank file
 *    Tip: js   |   Ime: sara
 * 2) Nalepi ceo ovaj sadrzaj i sacuvaj
 * 3) U theme.liquid, neposredno pre </body>, dodaj SAMO jednu liniju
 *    (nalazi se u uputstvu koje si dobio uz fajl)
 *
 * Nema API kljuca u ovom fajlu i ne sme ga biti - kljuc stoji na Workeru.
 */

(function () {

  /* ---- izgled se ubacuje iz koda, bez <style> taga u temi ---- */
  var stil = document.createElement('style');
  stil.id = 'sh-sara-css';
  stil.textContent = `/* ---- Sara: paleta preuzeta iz postojećeg widgeta (žalfija + lan) ---- */
#sh-sara, #sh-sara * { box-sizing: border-box; }
#sh-sara {
  --sara-zalfija:  #121212;
  --sara-tamna:    #000000;
  --sara-lan:      #F2F2F2;
  --sara-krem:     #FFFFFF;
  --sara-mastilo:  #121212;
  --sara-tiha:     #6B6B6B;
  --sara-ivica:    #E5E5E5;

  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 2147483000;
  font-family: Lato, -apple-system, "Segoe UI", sans-serif;
  color: var(--sara-mastilo);
}

/* ---- dugme za otvaranje: pilula sa imenom, ne goli oblačić ---- */
#sh-sara-launcher {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 9px 20px 9px 9px;
  border: 0;
  border-radius: 999px;
  background: var(--sara-zalfija);
  color: var(--sara-krem);
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: .01em;
  cursor: pointer;
  box-shadow: 0 10px 28px rgba(18,18,18,.24);
  transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
}
#sh-sara-launcher:hover { transform: translateY(-2px); background: var(--sara-tamna); }
#sh-sara-launcher:focus-visible { outline: 3px solid var(--sara-zalfija); outline-offset: 3px; }
#sh-sara-launcher .sh-av { width: 34px; height: 34px; font-size: 15px; }

/* avatar */
#sh-sara .sh-av {
  display: grid;
  place-items: center;
  width: 38px; height: 38px;
  border-radius: 50%;
  background: var(--sara-krem);
  color: var(--sara-zalfija);
  font-weight: 900;
  letter-spacing: .02em;
  flex: none;
}

/* ---- panel ---- */
#sh-sara-panel {
  position: absolute;
  right: 0; bottom: 0;
  width: 384px;
  max-width: calc(100vw - 32px);
  height: 560px;
  max-height: calc(100vh - 40px);
  display: none;
  flex-direction: column;
  overflow: hidden;
  background: var(--sara-krem);
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(18,18,18,.28);
  animation: sh-sara-in .22s ease-out;
}
#sh-sara.sh-open #sh-sara-panel { display: flex; }
#sh-sara.sh-open #sh-sara-launcher { display: none; }
@keyframes sh-sara-in { from { opacity: 0; transform: translateY(12px); } }

/* ---- zaglavlje; ispod njega šav, kao na tkanini ---- */
#sh-sara-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 16px 14px;
  background: var(--sara-zalfija);
  color: var(--sara-krem);
  border-bottom: 2px dashed rgba(255,255,255,.32);
}
#sh-sara-head .sh-ime { font-size: 17px; font-weight: 700; line-height: 1.2; }
#sh-sara-head .sh-pod { font-size: 12px; opacity: .78; margin-top: 2px; }
#sh-sara-close {
  margin-left: auto;
  width: 32px; height: 32px;
  border: 0; border-radius: 50%;
  background: rgba(255,255,255,.14);
  color: var(--sara-krem);
  font-size: 19px; line-height: 1;
  cursor: pointer;
}
#sh-sara-close:hover { background: rgba(255,255,255,.26); }

/* ---- tok poruka ---- */
#sh-sara-tok {
  flex: 1;
  overflow-y: auto;
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  scrollbar-width: thin;
}
#sh-sara .sh-msg {
  max-width: 86%;
  padding: 11px 14px;
  font-size: 14.5px;
  line-height: 1.55;
  border-radius: 16px;
  white-space: pre-wrap;
  word-wrap: break-word;
  animation: sh-sara-msg .2s ease-out;
}
@keyframes sh-sara-msg { from { opacity: 0; transform: translateY(6px); } }
#sh-sara .sh-bot {
  align-self: flex-start;
  background: var(--sara-lan);
  border-bottom-left-radius: 5px;
}
#sh-sara .sh-user {
  align-self: flex-end;
  background: var(--sara-zalfija);
  color: var(--sara-krem);
  border-bottom-right-radius: 5px;
}
#sh-sara .sh-msg a { color: inherit; text-decoration: underline; text-underline-offset: 2px; }
#sh-sara .sh-user a { color: var(--sara-krem); }

/* tri tačke dok Sara kuca */
#sh-sara .sh-kuca { display: flex; gap: 5px; padding: 14px; }
#sh-sara .sh-kuca i {
  width: 7px; height: 7px; border-radius: 50%;
  background: var(--sara-tiha);
  animation: sh-sara-tacka 1.2s infinite ease-in-out;
}
#sh-sara .sh-kuca i:nth-child(2) { animation-delay: .18s; }
#sh-sara .sh-kuca i:nth-child(3) { animation-delay: .36s; }
@keyframes sh-sara-tacka { 0%,60%,100% { opacity:.3; transform:translateY(0);} 30% { opacity:1; transform:translateY(-4px);} }

/* ---- brza pitanja ---- */
#sh-sara-brza { display: flex; flex-wrap: wrap; gap: 7px; padding: 2px 16px 12px; }
#sh-sara-brza button {
  padding: 8px 13px;
  border: 1px solid var(--sara-ivica);
  border-radius: 999px;
  background: transparent;
  color: var(--sara-mastilo);
  font: inherit; font-size: 13px;
  cursor: pointer;
  transition: background .15s ease, border-color .15s ease;
}
#sh-sara-brza button:hover { background: var(--sara-lan); border-color: var(--sara-zalfija); }

/* ---- unos ---- */
#sh-sara-red {
  display: flex; align-items: center; gap: 9px;
  padding: 12px 14px 14px;
  border-top: 1px solid var(--sara-ivica);
  background: var(--sara-krem);
}
#sh-sara-input {
  flex: 1;
  padding: 12px 15px;
  border: 1px solid var(--sara-ivica);
  border-radius: 999px;
  background: #fff;
  font: inherit; font-size: 14.5px;
  color: var(--sara-mastilo);
}
#sh-sara-input:focus { outline: none; border-color: var(--sara-zalfija); }
#sh-sara-send {
  display: grid; place-items: center;
  width: 42px; height: 42px; flex: none;
  border: 0; border-radius: 50%;
  background: var(--sara-zalfija);
  color: var(--sara-krem);
  cursor: pointer;
  transition: background .15s ease;
}
#sh-sara-send:hover:not(:disabled) { background: var(--sara-tamna); }
#sh-sara-send:disabled { opacity: .45; cursor: default; }

#sh-sara-nota {
  padding: 0 16px 12px;
  font-size: 11.5px;
  color: var(--sara-tiha);
  text-align: center;
}

/* ---- telefon: panel preko celog ekrana ---- */
@media (max-width: 560px) {
  #sh-sara { right: 14px; bottom: 14px; }
  #sh-sara-panel {
    position: fixed;
    inset: 0;
    width: 100vw; height: 100dvh;
    max-width: none; max-height: none;
    border-radius: 0;
  }
  #sh-sara-launcher span.sh-tekst { display: none; }
  #sh-sara-launcher { padding: 9px; }
}

@media (prefers-reduced-motion: reduce) {
  #sh-sara *, #sh-sara *::before { animation: none !important; transition: none !important; }
}`;
  document.head.appendChild(stil);

  const ENDPOINT = 'https://sarahome-ai-vodic.skaljak26.workers.dev';

  const BRZA = [
    'Koji čaršaf ide na moj dušek?',
    'Koje boje su dostupne?',
    'Koliko traje dostava?'
  ];

  const istorija = [];
  let uToku = false;

  /* stari widget uklanjamo sa strane da ne bude dva */
  function skloniStari() {
    document.getElementById('sarahome-vodic-root')?.remove();
  }
  skloniStari();
  const posmatrac = new MutationObserver(skloniStari);
  posmatrac.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => posmatrac.disconnect(), 12000);

  /* tekst modela nikad ne ide sirov u HTML — prvo se neutrališe, pa se
     tek onda prepoznaju linkovi i podebljanje */
  function uHtml(tekst) {
    const bezbedno = String(tekst)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
    return bezbedno
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/(https?:\/\/[^\s<]+[^\s<.,;:!?)])/g,
               '<a href="$1" target="_blank" rel="noopener">$1</a>');
  }

  const el = {};

  function napravi() {
    const kutija = document.createElement('div');
    kutija.id = 'sh-sara';
    kutija.innerHTML = [
      '<button id="sh-sara-launcher" aria-label="Otvori razgovor sa Sarom">',
        '<span class="sh-av">S</span><span class="sh-tekst">Pitajte Saru</span>',
      '</button>',
      '<div id="sh-sara-panel" role="dialog" aria-label="Razgovor sa Sarom">',
        '<div id="sh-sara-head">',
          '<span class="sh-av">S</span>',
          '<div><div class="sh-ime">Sara</div>',
          '<div class="sh-pod">Automatski asistent Sarahome</div></div>',
          '<button id="sh-sara-close" aria-label="Zatvori">&times;</button>',
        '</div>',
        '<div id="sh-sara-tok"></div>',
        '<div id="sh-sara-brza"></div>',
        '<div id="sh-sara-red">',
          '<input id="sh-sara-input" type="text" placeholder="Napišite pitanje..." ',
            'autocomplete="off" aria-label="Vaše pitanje">',
          '<button id="sh-sara-send" aria-label="Pošalji">',
            '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" ',
            'stroke="currentColor" stroke-width="2.2" stroke-linecap="round" ',
            'stroke-linejoin="round"><path d="M22 2 11 13"/>',
            '<path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>',
          '</button>',
        '</div>',
        '<div id="sh-sara-nota">Odgovara automatski. Za reklamacije pozovite 069/184 7222.</div>',
      '</div>'
    ].join('');
    document.body.appendChild(kutija);

    el.koren    = kutija;
    el.launcher = kutija.querySelector('#sh-sara-launcher');
    el.close    = kutija.querySelector('#sh-sara-close');
    el.tok      = kutija.querySelector('#sh-sara-tok');
    el.brza     = kutija.querySelector('#sh-sara-brza');
    el.input    = kutija.querySelector('#sh-sara-input');
    el.send     = kutija.querySelector('#sh-sara-send');
  }

  function poruka(ko, tekst) {
    const d = document.createElement('div');
    d.className = 'sh-msg sh-' + ko;
    d.innerHTML = uHtml(tekst);
    el.tok.appendChild(d);
    el.tok.scrollTop = el.tok.scrollHeight;
    return d;
  }

  function kuca() {
    const d = document.createElement('div');
    d.className = 'sh-msg sh-bot sh-kuca';
    d.innerHTML = '<i></i><i></i><i></i>';
    el.tok.appendChild(d);
    el.tok.scrollTop = el.tok.scrollHeight;
    return d;
  }

  function brzaPitanja(prikazi) {
    el.brza.innerHTML = '';
    if (!prikazi) return;
    BRZA.forEach(t => {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = t;
      b.addEventListener('click', () => { el.input.value = t; posalji(); });
      el.brza.appendChild(b);
    });
  }

  async function posalji() {
    const q = (el.input.value || '').trim();
    if (!q || uToku) return;

    uToku = true;
    brzaPitanja(false);
    poruka('user', q);
    el.input.value = '';
    el.send.disabled = true;
    const tacke = kuca();
    istorija.push({ role: 'user', content: q });

    try {
      const r = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: istorija.slice(-8) })
      });
      const j = await r.json();
      tacke.remove();

      if (!r.ok || j.error) {
        poruka('bot', j.error || 'Trenutno ne mogu da odgovorim. Pokušajte za koji trenutak.');
      } else {
        istorija.push({ role: 'assistant', content: j.reply });
        poruka('bot', j.reply);
      }
    } catch (e) {
      tacke.remove();
      console.error('Sara:', e);
      poruka('bot', 'Veza je prekinuta. Proverite internet i pokušajte ponovo.');
    }

    el.send.disabled = false;
    uToku = false;
    el.input.focus();
  }

  function otvori() {
    el.koren.classList.add('sh-open');
    if (!el.tok.children.length) {
      poruka('bot', 'Dobar dan! Pitajte me o veličinama, materijalima i dostupnosti.');
      brzaPitanja(true);
    }
    setTimeout(() => el.input.focus(), 60);
  }

  function pokreni() {
    napravi();
    el.launcher.addEventListener('click', otvori);
    el.close.addEventListener('click', () => el.koren.classList.remove('sh-open'));
    el.send.addEventListener('click', posalji);
    el.input.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); posalji(); }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') el.koren.classList.remove('sh-open');
    });
    console.log('Sara: novi izgled aktivan');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pokreni);
  } else {
    pokreni();
  }
})();